import styled from 'styled-components';

import { FormField, FormFieldProps } from 'ui/formField';
import { Caption, colors, spacing } from 'ui/theme';
import { TagGroup } from 'ui/tags';

interface StyledFormFieldProps extends FormFieldProps {
  /** Is the field currently in focus? */
  isFocused?: boolean;
}

export const StyledFormField = styled(({ isFocused, ...rest }: StyledFormFieldProps) => (
  <FormField {...rest} />
))`
  label {
    width: ${({ isFocused }) => (!isFocused ? '100%' : 'auto')};
    display: flex;
    justify-content: space-between;
  }
  margin-bottom: ${spacing.quarter};
`;

export const Subtitle = styled(Caption)`
  color: ${colors.textSecondary};
  display: block;
  padding-top: ${spacing.quarter};
  margin-top: 0;
`;

export const StyledTagGroup = styled(TagGroup)`
  margin-top: ${spacing.half};
`;
